import { Outlet } from "react-router";

import { PortalHeader } from "@components/Headers";

export const PortalPage = () => {
  return (
    <>
      <PortalHeader />
      <Outlet />
    </>
  );
};
